import Vue from "vue";
import VueRouter from "vue-router";

// import Home from '@/views/Home.vue'
import customerManagementRoutes from "./customer-management";
import bootPageRoutes from "./boot-page";
import Dashbroad from "@/views/Dashboard.vue";
import DataAssistant from "@/views/dataAssitant.vue";

Vue.use(VueRouter);

import overseasBuyer from "@/router/overseas-buyer/index";
import intellectMarketing from "@/router/intellect-marketing/index";
import costCenter from "@/router/cost-center/index";
import productCaseRoutes from "@/router/product-case/index";
import zhenyunPageRouters from "./zhenyun-page/index"
import { ossUrlLink } from "@/utils/config";
import { onlineUrl, appUrl, presentUrl } from "@/utils/config";
import productOpportunityIcon from "@/assets/svg/产品商机.svg";

// 重写push和replace方法去除掉报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    redirect: "dashboard",
  },
  // 非业务需求的Test页面
  // {
  //   path: '/example',
  //   name: 'test-example',
  //   component: Home,
  //   meta: {
  //     title: '例子example',
  //     keepAlive: true,
  //     disableScroll: false,
  //     broadcast: true,
  //     icon: 'el-icon-s-home'
  //   }
  // },
  // 业务看板
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashbroad,
    meta: {
      title: "业务看板",
      // newTab: false,
      noBg: true,
      // broadcast: false,
      icon: 'icon-dashboard',
    }
  },
  // 图纸协作
  {
    path: `${appUrl}/saas-drawing/drawing-library`,
    name: 'drawing-aysnc',
    component: ()=> import('@/views/otherUrlView.vue'),
    meta: {
      title: '图纸协作',
      isExternal: true,
      newTab: true,
      // newTab: false,
      noBg: true,
      // broadcast: false,
      icon: 'icon-tuzhixiezuo',
      isNew: false,
    }
  },
  // 智能报价器 (MKP-21927 隐藏)
  // {
  //   path: `${onlineUrl}/smart`,
  //   name: 'smart',
  //   component: ()=> import('@/views/otherUrlView.vue'),
  //   meta: {
  //     title: '智能报价器',
  //     isExternal: true,
  //     newTab: true,
  //     // newTab: false,
  //     noBg: true,
  //     // broadcast: false,
  //     icon: "icon-zhinengbaojiaqi",
  //     isNew: false,
  //     // isFreeTrial:true
  //   }
  // },
  // 询盘机会
  {
    path: "/supplier",
    name: "supplier",
    component: () => import("@/views/otherUrlView.vue"),
    meta: {
      title: "询盘机会",
      // newTab: false,
      noBg: true,
      // broadcast: false,
      icon: 'icon-xunpanjihui',
    },
    children: [
      {
        path: `${onlineUrl}/matched-rfqs/1`,
        name: "matched-rfqs",
        component: () => import("@/views/otherUrlView.vue"),
        meta: {
          title: '匹配询盘',
          noBg:true,
          isExternal: true,
          newTab: true
          // keepAlive: true
        }
      },
      {
        path: `${ossUrlLink}s/#/supplier/rfq/list`,
        name: 'rfq-list',
        component: ()=> import('@/views/otherUrlView.vue'),
        meta: {
          title: '海智专区',
          isExternal: true,
          newTab: true,
          // newTab: false,
          noBg: true,
          // broadcast: false,
        }
      },
    ],
  },
  // 站内信
  {
    path: `${onlineUrl}/supplier/message/unread-list/1`,
    name: 'unread-list',
    component: ()=> import('@/views/otherUrlView.vue'),
    meta: {
      title: '站内信',
      noBg:true,
      isExternal: true,
      newTab: true,
      icon: 'icon-zhanneixin1',
      // keepAlive: true
    }
  },
  // 拓品管理
  {
    path: '/topping',
    name: 'topping',
    component: ()=> import('@/views/otherUrlView.vue'),
    meta: {
      title: '产品管理',
      // newTab: false,
      noBg: true,
      // broadcast: false,
      icon: 'icon-chanpinguanli',
    },
    children: [
      {
        path: `${onlineUrl}/saas-topping/product-manage-list`,
        name: 'topping_product-manage-list',
        component: ()=> import('@/views/otherUrlView.vue'),
        meta: {
          title: '产品列表',
          isExternal: true,
          newTab: false
        }
      },
      {
        path: `${onlineUrl}/saas-topping/product/product-category-list`,
        name: 'topping_product-category-list',
        component: ()=> import('@/views/otherUrlView.vue'),
        meta: {
          title: '产品分类',
          isExternal: true,
          newTab: false,
        }
      },
      {
        path: `${onlineUrl}/saas-topping/home-manage`,
        name: 'topping_home-manage',
        component: ()=> import('@/views/otherUrlView.vue'),
        meta: {
          title: '首页管理',
          isExternal: true,
          newTab: false,
        }
      },
    ]

  },
  // 产品商机
  {
    path: `${onlineUrl}/purchase-order/supplier/product-opportunity/list`,
    name: 'supplier-product-opportunity-list',
    component: ()=> import('@/views/otherUrlView.vue'),
    meta: {
      title: '产品商机',
      isExternal: true,
      newTab: false,
      noBg: true,
      svgIcon: productOpportunityIcon,
    }
  },
  // 生态合作伙伴订单专区
  {
    path: `${presentUrl}/partner/introduce`,
    name: "ecological-cooperation-zone",
    component: ()=> import('@/views/otherUrlView.vue'),
    meta: {
      title: '生态合作订单专区',
      isExternal: true,
      newTab: true,
      // newTab: false,
      noBg: true,
      // broadcast: false,
      icon: 'icon-shengtaihezuo',
      // isNew: true,
    }
  },
  // 交易管理
  {
    path: "/order",
    name: "supplier-order",
    meta: {
      title: '交易管理',
      icon: 'icon-jiaoyiguanli1',
    },
    children: [
      {
        path: `${onlineUrl}/purchase-order/supplier/order/all-list`,
        name: "supplier-order-allList",
        meta: {
          title: "我的订单",
          isExternal: true,
        },
      },
      {
        path: `${onlineUrl}/purchase-order/supplier/order/after-sales/refund-detail`,
        name: "supplier-refund-detail",
        meta: {
          title: "售后处理",
          isExternal: true,
          mark:10
        }
      },
      {
        path: `${onlineUrl}/purchase-order/contract/contract-management`,
        name: "contractManagement",
        meta: {
          title: '采购合同签订',
          isExternal: true
        }
      }
    ]
  },
  // 收款管理
  {
    path: "/payment",
    name: "supplier-payment-manage",
    meta: {
      title: '收款管理', // 收款管理
      icon: "icon-caiwuguanli1"
    },
    children: [
      {
        path: `${onlineUrl}/purchase-order/supplier/financial/funds`,
        name: "supplier-financial-funds",
        meta: {
          title: "资金管理",
          isExternal: true,
        },
      },
      {
        path: `${onlineUrl}/purchase-order/supplier/invoice/invoicable`,
        name: "supplier-financial-invoicable",
        meta: {
          title: "发票管理",
          isExternal: true,
        },
      },
      {
        path: `${onlineUrl}/purchase-order/supplier/financial/collection-set`,
        name: "supplier-financial-collectionSet",
        meta: {
          title: '收款设置',
          isExternal: true
        }
      },
      {
        path: `${onlineUrl}/purchase-order/supplier/financial/part-account`,
        name: 'supplier-financial-partAccount',
        meta: {
          title: '分账方设置',
          isExternal: true
        }
      }
    ]
  },
  // 物流服务
  {
    path: '/transport',
    name: 'transport',
    meta: {
      title: '物流服务',
      // newTab: false,
      noBg: true,
      // broadcast: false,
      icon: 'icon-wuliu',
      // isFreeTrial: true,
      // freeTrialText: '体验版',
    },
    children: [
      {
        path: `${onlineUrl}/purchase-order/supplier/transport`,
        name: 'supplier-transport',
        meta: {
          title: '国内快递/物流寄件',
          isExternal: true,
          newTab: true,
          // newTab: false,
          noBg: true,
          // broadcast: false,
          icon: 'icon-tuzhixiezuo',
          isNew: false,
        }
      },
      {
        path: `${onlineUrl}/purchase-order/supplier/transport/logistics`,
        name: 'supplier-transport-logistics',
        meta: {
          title: '物流对账结算',
          isExternal: true,
          newTab: true,
          // newTab: false,
          noBg: true,
          // broadcast: false,
          icon: 'icon-tuzhixiezuo',
          isNew: false,
        }
      },
      {
        path: `${onlineUrl}/purchase-order/supplier/transport/address`,
        name: 'supplier-transport-address',
        meta: {
          title: '地址管理',
          isExternal: true,
          newTab: true,
          // newTab: false,
          noBg: true,
          // broadcast: false,
          icon: 'icon-tuzhixiezuo',
          isNew: false,
        }
      },
    ],
  },
  // 企业管理
  costCenter,
  // 零件管理
  ...productCaseRoutes,
  // 智工嗨搜
  overseasBuyer,
  // 客户管理
  ...customerManagementRoutes,
  // 引导页
  ...bootPageRoutes,
  // 数据统计
  // 甄云专区路由
  ...zhenyunPageRouters,
  {
    path: '/data-assistant',
    name: 'dataAssistant',
    component: DataAssistant,
    meta: {
      title: '数据统计',
      // isExternal: true,  //新开页打开
      // newTab: false,
      noBg: true,
      // broadcast: false,
      icon: 'icon-shujutongji',
    }
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/403.vue"),
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  linkActiveClass: "router-active",
  base: process.env.BASE_URL,
  routes,
});
// console.log('所有的路由', router)

export default router;
